import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import BasicQueryInput from "./searchbar/queryinput/AsyncBasicQueryInput";
const Wrapper = styled.div`
  width: 25%;
  min-width: 300px;
  max-width: 500px;
  display: flex;
  align-items: center;

  &::before {
    box-shadow: 17px 0 16px -16px rgb(0 0 0 / 40%) inset;
  }
`;
const QueryInfo = styled.div(
  ({ theme }) => css`
    margin-left: 10px;
    border: 1px dashed ${theme.colors.input.border};
    display: flex;
    align-items: center;
    width: 100%;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 0 5px;
    min-height: 34px;
    border-left: 0;

    .query {
      flex: 1;
    }
  `
);
const StyledBasicQueryInput = styled(BasicQueryInput)`
  &&.ace-queryinput {
    border: none;
  }
`;
const ResetButton = styled(Button)`
  margin-left: 5px;
`;
const WidgetQueryOverride = ({ value, onReset }) => {
  const { t } = useTranslation("search");
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(QueryInfo, null, /* @__PURE__ */ React.createElement(StyledBasicQueryInput, { disabled: true, value: value.query_string, height: 34, wrapEnabled: false, maxLines: 1 }), /* @__PURE__ */ React.createElement(ResetButton, { bsSize: "xs", bsStyle: "primary", onClick: onReset, "data-testid": "reset-global-query" }, t("widget_query.reset_global_filter"))));
};
export default WidgetQueryOverride;
